<template>
  <section class="col-md-12 col-xs-12 block-card-list">
    <template v-if="registerLinkLoading || ipayLoading">
      <bounce-loader style="margin-bottom: 40px" />
    </template>
    <template v-else>
      <credit-card class="col-md-12 col-xs-12 mx0-for-credit-cart-modal"
                   v-for="(card, index) in cards"
                   v-if="showCards > index"
                   :card="card"
                   :key="card.details.uid"
      />
      <div class="col-md-12 col-xs-12 mb10" v-if="cards.length > showCards">
      <span class="load-more" @click="loadMore">
        {{ $t('Load more card') }}
      </span>
      </div>
      <div class="flex-desktop">
        <div class="col-xs-12 col-sm-6 pl0 add-new-card">
          <button-full class="button-add-new-card" @click.native="confirm">
            {{ $t('Confirm') }}
          </button-full>
        </div>
        <div class="col-xs-12 col-sm-6 pr0 add-new-card">
          <button-full class="button-add-new-card" @click.native="openAddCardLink">
            {{ $t('Add another card') }}
          </button-full>
        </div>
      </div>
    </template>

  </section>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import CreditCard from '../../../../../../../modules/ipay-payment/components/CreditCard'
import ButtonFull from '../../../../theme/ButtonFull'
import BounceLoader from 'theme/components/theme/blocks/Home/Preloaders/BounceLoader'

export default {
  name: 'CreditCardsList',
  components: {
    CreditCard,
    ButtonFull,
    BounceLoader
  },
  data () {
    return {
      showCards: 3,
      ipayLoading: false
    }
  },
  async created () {
    this.ipayLoading = true
    await this.getUserStatus({
      customerId: this.getCustomerId,
      phoneNumber: this.getPhoneNumber(true)
    })
    .then(() => this.loadIPayActionLink({
      customerId: this.getCustomerId,
      phoneNumber: this.getPhoneNumber(true),
      lang: 'ua',
      successUrl: this.successUrl
    }))
    .then(async res => {
      if (this.isUserExists) {
        await this.loadCards({
          customerId: this.getCustomerId,
          phoneNumber: this.getPhoneNumber(true)
        })
      }
      return res
    })
    .finally(() => {
      this.ipayLoading = false
    })
  },
  computed: {
    ...mapGetters({
      isUserExists: 'ipay-payment-user/isUserExist',
      cards: 'ipay-payment-user/getCards',
      currentLocation: 'locations/getActiveLocation',
      personalDetails: 'checkout/getPersonalDetails',
      registerLinkLoading: 'ipay-payment-user/isRegisterLinkLoading',
      getPhoneNumber: 'user/getPhoneNumber'
    }),
    getCustomerId () {
      return this.$store.state.user.current.id
    },
    successUrl () {
      return window ? window.location.href : `/checkout/${this.currentLocation.code}`
    }
  },
  methods: {
    ...mapActions({
      loadCards: 'ipay-payment-user/getCardsList',
      getUserStatus: 'ipay-payment-user/getUserStatus',
      openAddCardLink: 'ipay-payment-user/openIPayActionLink',
      loadIPayActionLink: 'ipay-payment-user/loadIPayActionLink'
    }),
    loadMore () {
      if (this.cards.length > this.showCards) {
        this.showCards += 3
      }
    },
    confirm () {
      this.$bus.$emit('modal-hide', 'credit-cards-list')
    }
  },
  watch: {
    'personalDetails.phoneNumber': async function () {
      this.ipayLoading = true
      await this.getUserStatus({
        customerId: this.getCustomerId,
        phoneNumber: this.getPhoneNumber(true)
      })
      .then(() => this.loadIPayActionLink({
        customerId: this.getCustomerId,
        phoneNumber: this.getPhoneNumber(true),
        lang: 'ua',
        successUrl: this.successUrl
      }))
      .then(async res => {
        if (this.isUserExists) {
          await this.loadCards({
            customerId: this.getCustomerId,
            phoneNumber: this.getPhoneNumber(true)
          })
        }
        return res
      })
      .finally(() => {
        this.ipayLoading = false
      })
    }
  }
}
</script>
<style scoped lang="scss">
  .mx0-for-credit-cart-modal {
    margin-left: 0!important;
    margin-right: 0!important;
  }
  .block-card-list {
    padding: 0 70px;
    margin-top: 10px;
    display: flex;
    flex-wrap: wrap;
    @media (max-width: 520px) {
      padding: 0;
    }
  }
  .col-md-6 {
    @media only screen and (min-width: 769px) {
      flex-basis: 48%;
      max-width: 48%;
    }
  }
  .add-new-card {
    margin: 0 auto;
    margin-bottom: 15px;
    @media (max-width: 600px) {
      padding: 0;
    }
  }
  .load-more {
    color: #11bb2e;
    text-decoration: underline;
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.05px;
    text-align: center;
    cursor: pointer;
  }
  .flex-desktop {
    width: 100%;
    display: flex;
    @media (max-width: 600px) {
      display: block;
    }
  }
 .col-sm-6 {
   @media only screen and (min-width: 601px) {
     flex-basis: 50%;
     max-width: 50%;
   }
 }
</style>
<style>
  .button-add-new-card {
    min-width: 180px;
    padding-top: 15px!important;
    padding-bottom: 15px!important;
  }
</style>
